module.exports = __webpack_public_path__ + "static/cover-5b2776e866377d2995bd57ae066cd784.jpg";